import React, { ReactNode } from 'react';
import { Link } from 'wouter';
import { uuid } from '../CodesThatsGottaGoSomewhereElse';

export const MaybeLink = ({ to, onClick, children }: { to?: string, onClick?: (e: React.MouseEvent) => void, children: ReactNode }) => {
    if (onClick) {
        return <a id={uuid()} draggable={false} onClick={onClick}>{children}</a>;
    }
    else {
        return <Link draggable={false} to={to}>{children}</Link>;
    }
};
